// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3__Q0","errors":"Errors_errors__19vzH"};